import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'

import globalMU from "globalMU"
import { produtoMarkupAlterado } from "app/types/Markup"

export async function alterarPrecoItemSimulacaoMarkup(identificadorOrcamento: string, precosModificados: produtoMarkupAlterado[]) {
    try {
        globalMU.blockUI({tryPassiveLoading: true})
        const orcamentoAtualizado = await microuniversoApi.Orcamento.aplicarPrecoSimuladoMarkup(identificadorOrcamento, precosModificados);
        
        const atualizarOrcamento = () => {
            
            store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
        }
        const atualizarEstadoItensLegado = () => {
            for(let itemAtualizado of (orcamentoAtualizado.ItensOrcamento ?? [])) {
                store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                    identificador: itemAtualizado.Identificador,
                    dadosItem: itemAtualizado
                }))
            }
        }

        atualizarOrcamento()
        atualizarEstadoItensLegado()

        return !("HasErrors" in orcamentoAtualizado)
    }
    finally {
        globalMU.unblockUI()
    }
}
